import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() { 

      this.canvasForm = this.svg
      .append('g')
      .attr('transform',`translate(0.5, 0.5)`)
      .style('font-family', 'roboto').style('cursor', 'default')

      if(this.title.visible == 'Y') {
        this.canvasForm
        .append('text')
        .attr('id', `TITLE_${this.localId}`)
        .attr('transform',`translate(${this.title.x}, ${this.title.y})`)
        .attr('font-size', this.title.tSize).attr('fill', this.title.tColor)
        .text(this.menus.list.find(f=> f.code ==this.current.menu).title)
      }

      this.draw_Menus()
      this.init_ChartData()
      this.draw_ChartAxis()
      this.draw_Grid()

      this.draw_chartTimeline()
      this.chart_Controller()
      this.draw_Milestone()
      this.draw_legends()
      

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    
    },

  }
}